module.exports = __webpack_public_path__ + "static/media/NS_5to.392c1116.jpg";